import React from "react";
import { BedDouble, Maximize, Zap, Calendar, Wallet, Home as HomeIcon } from "lucide-react";
import { useT } from "../../lib/i18n";
import { formatPrice } from "../../lib/api";

export const DetailFacts = ({ listing }) => {
  const { t } = useT();
  const facts = [
    { icon: BedDouble, label: t("detail.bedrooms"), value: listing.bedrooms },
    { icon: Maximize, label: t("detail.m2"), value: `${listing.m2} m²` },
    { icon: Zap, label: t("detail.energy"), value: listing.energy_label || "—" },
    { icon: HomeIcon, label: t("detail.type"), value: listing.type || "—" },
    { icon: Calendar, label: t("detail.available"), value: listing.available_from || "—" },
    { icon: Wallet, label: t("detail.income"), value: listing.income_required ? formatPrice(listing.income_required) : "—" },
  ];
  return (
    <>
      <h2 className="mt-8 font-display text-xl font-bold text-navy">{t("detail.facts")}</h2>
      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
        {facts.map((f, i) => (
          <div key={i} className="rounded-2xl border border-border bg-white p-4">
            <f.icon size={18} className="text-brandblue" />
            <div className="mt-2 text-xs text-slate-400">{f.label}</div>
            <div className="font-display text-base font-bold text-navy">{f.value}</div>
          </div>
        ))}
      </div>
    </>
  );
};
